var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2660_1872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0762 2.11719H17.0992V15.2291H10.0762V2.11719Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5221 8.67177C10.5221 6.00773 11.726 3.64475 13.5765 2.11576C12.2166 1.00382 10.4999 0.332031 8.62707 0.332031C4.19011 0.332031 0.600586 4.06169 0.600586 8.67177C0.600586 13.2817 4.19011 17.0115 8.62697 17.0115C10.4998 17.0115 12.2165 16.3397 13.5765 15.2277C11.726 13.7219 10.5221 11.3358 10.5221 8.67177Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5748 8.67177C26.5748 13.2817 22.9853 17.0115 18.5484 17.0115C16.6756 17.0115 14.9589 16.3397 13.5988 15.2277C15.4717 13.6988 16.6533 11.3358 16.6533 8.67177C16.6533 6.00773 15.4493 3.64475 13.5988 2.11576C14.9588 1.00382 16.6756 0.332031 18.5484 0.332031C22.9853 0.332031 26.5748 4.08491 26.5748 8.67177Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2660_1872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 21,
    fill: "white",
    transform: "translate(0.600586 0.332031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard_logo.9afc4bb8088a770b6394f8b305936e44.svg";
export { ForwardRef as ReactComponent };